import React from "react";
import WarningIcon from "@material-ui/icons/Warning";
import { Typography, Button, makeStyles, Drawer, Box } from "@material-ui/core";
import { remCalc } from "../../utils/helpers";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  paper: {
    width: remCalc(448)
  },
  header: {
    height: 80,
    borderBottom: theme.variables.border,
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 3)
  },
  title: {
    fontWeight: 500,
    marginLeft: theme.spacing(3)
  },
  infoText: {
    lineHeight: 1.5,
    fontSize: "1rem",
    marginBottom: theme.spacing(3)
  },
  btn: {
    textTransform: "none"
  }
}));

export default function IncompleteAccountDrawer({ open }) {
  const classes = useStyles();
  return (
    <Drawer
      disableEscapeKeyDown
      open={open}
      anchor="left"
      classes={{
        paper: classes.paper,
        root: classes.root
      }}
      ModalProps={{
        disablePortal: true,
        hideBackdrop: true
      }}
    >
      <Box className={classes.header}>
        <WarningIcon color="error" />
        <Typography variant="h5" className={classes.title}>
          Update payment method
        </Typography>
      </Box>
      <Box p={3}>
        <Typography className={classes.infoText}>
          We were unable to process your last payment. Please update your
          payment method in order to continue using Routetitan.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          component={RouterLink}
          to="payment/edit-payment-method"
          className={classes.btn}
        >
          Update payment
        </Button>
      </Box>
    </Drawer>
  );
}
